import '@loyal_molecules/menu.css'
import '@loyal_molecules/menu-toggle.css'

import React from 'react'
import MainMenuPlaceholder from './MainMenuPlaceholder'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import { CategoryMenu } from './CategoryMenu'
import PropTypes from 'prop-types'
import '@loyal_molecules/slider.css'

const MainMenuPublic = ({ categoryMenu }) => (
  <ReactPlaceholder ready customPlaceholder={<MainMenuPlaceholder />}>
    <nav className='container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-md-block d-print-none'>
      <div className='container'>
        <div className='menu menu-without-trade row row-eq-height flex-wrap flex-md-nowrap'>
          <div className='col'>
            <div className='row'>
              <CategoryMenu menus={categoryMenu} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  </ReactPlaceholder>
)

MainMenuPublic.propTypes = {
  categoryMenu: PropTypes.object
}

export default MainMenuPublic



// WEBPACK FOOTER //
// ./src/App/MainMenu/MainMenuPublic.js